import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ScoreDistributionTypeTable;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { scoreDistributionType } from '../../../../common/propTypes';
import { Component } from 'react';
import t from '@instructure/quiz-i18n/format-message';
import { Table } from '@instructure/ui-table';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var ScoreDistributionTypeTable = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ScoreDistributionTypeTable = /*#__PURE__*/function (_Component) {
  function ScoreDistributionTypeTable() {
    var _this2;
    _classCallCheck(this, ScoreDistributionTypeTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ScoreDistributionTypeTable, [].concat(args));
    _defineProperty(_this2, "renderFirstCell", function (content) {
      return jsx("div", {
        css: _this2.props.styles.firstTextContainer
      }, content);
    });
    _defineProperty(_this2, "renderCell", function (content) {
      return jsx("div", {
        css: _this2.props.styles.textContainer
      }, content);
    });
    _defineProperty(_this2, "renderRow", function (choice, choiceIndex) {
      var count = choice.count,
        score = choice.score,
        percentage = choice.percentage;
      return jsx(Table.Row, {
        key: choiceIndex
      }, jsx(Table.Cell, {
        themeOverride: {
          padding: '0'
        }
      }, _this2.renderFirstCell(score)), jsx(Table.Cell, {
        themeOverride: {
          padding: '0'
        }
      }, _this2.renderCell(count)), jsx(Table.Cell, {
        themeOverride: {
          padding: '0'
        },
        textAlign: "center"
      }, _this2.renderCell("".concat(percentage, "%"))));
    });
    return _this2;
  }
  _inherits(ScoreDistributionTypeTable, _Component);
  return _createClass(ScoreDistributionTypeTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        scores = _this$props.scores,
        itemId = _this$props.itemId,
        styles = _this$props.styles;
      var pointsHeaderId = "answer-frequency-summary-points-".concat(itemId);
      var respondentsHeaderId = "answer-frequency-summary-respondents-".concat(itemId);
      var percentageHeaderId = "answer-frequency-summary-percentage-".concat(itemId);
      return jsx("div", {
        css: styles.tableContainer
      }, jsx(Table, {
        caption: t('Score Frequency Summary'),
        elementRef: this.setTableRef
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: pointsHeaderId,
        height: "47px"
      }, t('Points')), jsx(Table.ColHeader, {
        id: respondentsHeaderId,
        height: "47px",
        textAlign: "center"
      }, t('Respondents')), jsx(Table.ColHeader, {
        id: percentageHeaderId,
        height: "47px",
        textAlign: "center"
      }, t('Percentage')))), jsx(Table.Body, null, scores.map(this.renderRow))));
    }
  }]);
}(Component), _defineProperty(_ScoreDistributionTypeTable, "displayName", 'ScoreDistributionTypeTable'), _defineProperty(_ScoreDistributionTypeTable, "componentId", "Quizzes".concat(_ScoreDistributionTypeTable.displayName)), _defineProperty(_ScoreDistributionTypeTable, "propTypes", {
  itemId: PropTypes.number.isRequired,
  scores: PropTypes.arrayOf(scoreDistributionType).isRequired,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _ScoreDistributionTypeTable)) || _class);
export default ScoreDistributionTypeTable;